import React from 'react';
export default function Header() {
  return (
      <header className="header flex-center">
        <h1 className="flex-center"><img src="/assets/images/master-logo.svg" height="52" alt="LOTTE C&amp;F"/> <span className="cf-none-mob">Cổng Thanh Toán LOTTE C&amp;F</span>
        </h1>
      </header>
  );
};